// import external dependencies
import 'jquery';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import 'slick-carousel/slick/slick.min';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Scroll to Animate and offset

$('a[href*="#"]:not([href="#"])').click(function() {
  if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
      $('html,body').animate({
        scrollTop: target.offset().top - 30, // offset here
      }, 1000); // animation speed here
      return false;
    }
  }
});

/// Accordion button for Read More button

$('.reveal-now').click(function(){
  $(this).nextAll().slideToggle();
});

// Close Mobile menu on click of any menu item

$('.menu-item a').click(function(){
  $('body').removeClass('nav-is-open');
});



// WEBPACK FOOTER //
// ./scripts/main.js